import { render, staticRenderFns } from "./TapingDots.vue?vue&type=template&id=63f74735&"
import script from "./TapingDots.vue?vue&type=script&lang=js&"
export * from "./TapingDots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports